import { LegalShell } from "@/components/LegalShell";

export default function DeliveryReturns() {
  return (
    <LegalShell title="Teslimat ve İade Şartları" updated="Haziran 2026">
      <p>
        Ustayla.com üzerinden satın alınan tüm ürünler <strong>dijital hizmet bakiyesi</strong> niteliğindedir.
        Platform, işveren ve usta arasında herhangi bir fiziksel ürün satışı veya kargo teslimatı yapmaz.
      </p>

      <h2>1. Dijital Teslimat</h2>
      <p>
        Cüzdanınıza yüklediğiniz bakiye ve satın aldığınız dijital hizmetler (iletişim bilgisi açma, ilan öne
        çıkarma vb.) <strong>ödeme onayından hemen sonra, anında</strong> hesabınıza tanımlanır. Teslimat için
        herhangi bir bekleme süresi veya fiziksel gönderim söz konusu değildir.
      </p>

      <h2>2. Cayma Hakkı ve İade</h2>
      <ul>
        <li>
          Mesafeli Sözleşmeler Yönetmeliği gereği, elektronik ortamda anında ifa edilen ( anında teslim edilen
          dijital) hizmetlerde, ifaya başlanmasıyla birlikte cayma hakkı sona erer.
        </li>
        <li>
          <strong>Henüz hiç kullanılmamış (harcanmamış) bakiye</strong> için, yükleme tarihinden itibaren 14 gün
          içinde iade talebinde bulunabilirsiniz. Kampanya/bonus bakiyeleri iade kapsamı dışındadır ve nakde
          çevrilemez.
        </li>
        <li>
          Kısmen veya tamamen harcanmış bakiyeler için iade yapılamaz; ancak hatalı/çift çekim gibi durumlarda
          talebiniz incelenerek ilgili tutar iade edilir.
        </li>
      </ul>

      <h2>3. İade Süreci</h2>
      <p>
        İade talepleriniz <strong>info@ustayla.com</strong> adresine iletildikten sonra en geç 14 iş günü içinde
        değerlendirilir. Uygun bulunan iadeler, ödemenin yapıldığı kart veya hesaba, ödeme kuruluşunun
        (iyzico) süreçlerine bağlı olarak gerçekleştirilir.
      </p>

      <h2>4. İletişim</h2>
      <p>
        Teslimat ve iade süreçleriyle ilgili tüm sorularınız için: <strong>info@ustayla.com</strong>
      </p>
    </LegalShell>
  );
}
